export default function buffaloReducer(state = [], action) {
  switch (action.type) {
    case "FETCH_BUFFALO":
      return [].concat.apply([], [...state, action.payload]);
    default:
      return state;
  }
}
